import { apiBaseUrl } from '../../util/api';

export const MAX_PHOTOS = 10;
export const MAX_IMAGE_BYTES = 10 * 1024 * 1024;
export const ACCEPT_IMAGES = 'image/jpeg,image/jpg,image/png,image/webp,image/avif';
export const newPhotoId = () =>
  `photo-${Date.now()}-${Math.random()
    .toString(36)
    .slice(2, 14)}`;

export const validatePhoto = file => {
  if (!ACCEPT_IMAGES.split(',').includes(file.type)) return 'invalid_image';
  if (!file.size || file.size > MAX_IMAGE_BYTES) return 'image_too_large';
  return null;
};

export const PHOTO_ERROR_CODES = [
  'invalid_image',
  'image_too_large',
  'too_many_images',
  'rate_limited',
  'photo_limit_reached',
  'processing_busy',
  'provider_rate_limited',
  'provider_quota_exceeded',
  'authentication_required',
  'permission_required',
  'unavailable',
  'timeout',
  'upload_failed',
];

const responseError = async (response, fallback) => {
  const data = await response.json().catch(() => ({}));
  const error = new Error(PHOTO_ERROR_CODES.includes(data.code) ? data.code : fallback);
  error.status = response.status;
  const retry = Number(response.headers.get('Retry-After'));
  error.retryAfter = response.status === 429 ? (retry > 0 ? Math.min(86400, retry) : 60) : 0;
  return error;
};

export const processListingPhoto = async file => {
  const body = new FormData();
  body.append('image', file);
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 200000);
  try {
    const response = await fetch(`${apiBaseUrl()}/api/ai/listing-images/process`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'X-Listing-Photo-Request': '1', 'X-Listing-Photo-Id': newPhotoId() },
      body,
      signal: controller.signal,
    });
    if (!response.ok) {
      throw await responseError(response, 'processing_failed');
    }
    const blob = await response.blob();
    if (blob.type !== 'image/jpeg' || !blob.size || blob.size > MAX_IMAGE_BYTES) {
      throw new Error('processing_failed');
    }
    return new File([blob], 'prepared-inventory.jpg', { type: 'image/jpeg' });
  } catch (e) {
    if (e.name === 'AbortError') throw new Error('timeout');
    throw e;
  } finally {
    clearTimeout(timer);
  }
};
